<ifr-page-title pageTitle="'LANG_HOME_TERMINAL' | translate "/>

<terminal-container />

<iflx-scroll-up-directive></iflx-scroll-up-directive>
